import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './message.css'
import { apiUrl_api, baseUrl, } from './url.jsx';
import React from 'react';
import { Card, Row, Col, Button, Table, } from 'react-bootstrap';


function Pricing({ loginInfo }) {
    console.log(loginInfo);
    const handlePricingClick = (time, amount, description, event_key, currency) => {
        console.log(amount, description, apiUrl_api + "/pay/tripe_pay_application");
        console.log(loginInfo.uid);
        const postData = {
            url: baseUrl,
            uid: loginInfo.uid,
            time: time,
            amount: amount,
            currency: 'CNY',
            description: "Meeting " + description,
            event_key: event_key,
            currency: currency,
            mail: loginInfo.mail,
            pay_app: "Meeting",
        }

        // 发起支付申请
        fetch(apiUrl_api + "/pay/stripe_pay_application", {
            method: "POST",
            body: JSON.stringify(postData),
            headers: { "Content-Type": "application/json", },
            keepalive: true,
            credentials: "include", // 允许发送 cookie
        })
        .then(response => response.json())
        .then(data => {
            console.log(data, data.pay_url);
            // 获取重定向URL
            window.location.assign(data.pay_url);
        })
        .catch(error => {
            console.error(error);
        });

        // 支付完成后轮询 后端 2 分钟
        let startTime = new Date().getTime(); // 记录开始时间
    }

    return (
        <>
            <h1 className="text-center mt-5 mb-5">Pricing</h1>
            {/* <p className="fs-5 text-body-secondary">Quickly build an effective pricing table for your potential customers with this Bootstrap example. It’s built with default Bootstrap components and utilities with little customization.</p> */}
            <Row className='row-cols-1 row-cols-md-3 mb-3 text-center'>                              
                <Col className="col-md-6 col-lg-3">
                    <Card className='mb-4 rounded-3 shadow-sm'>
                        <Card.Header className='py-3'>
                            <h4 className="my-0 fw-normal">Free</h4>
                        </Card.Header>
                        <Card.Body>
                            <h1 className="card-title pricing-card-title">免费<small className="text-body-secondary fw-light"></small></h1>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>10 分钟/天</li>
                                <li>永久</li>
                            </ul>
                            <Button
                                variant="outline-secondary"
                                className="w-100 btn btn-lg"
                                onClick={() => handlePricingClick('0', '0', '每天10分钟', "MEETING000", "CNY")}
                                disabled={true}
                            >Get starte
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="col-md-6 col-lg-3">
                    <Card className='mb-4 rounded-3 shadow-sm'>
                        <Card.Header className='py-3'>
                            <h4 className="my-0 fw-normal">Pro</h4>
                        </Card.Header>
                        <Card.Body>
                            <h1 className="card-title pricing-card-title">19.9<small className="text-body-secondary fw-light">/月</small></h1>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>90 分钟/天</li>
                                <li>30 天</li>
                            </ul>
                            <Button
                                variant="outline-success"
                                className="w-100 btn btn-lg"
                                onClick={() => handlePricingClick('90', '1990', '30天每天90分钟', "MEETING001", "CNY")}
                            >Get started</Button>
                        </Card.Body>
                    </Card>
                </Col>
                <Col className="col-md-6 col-lg-3">
                    <Card className='mb-4 rounded-3 shadow-sm'>
                        <Card.Header className='py-3'>
                            <h4 className="my-0 fw-normal">Enterprise</h4>
                        </Card.Header>
                        <Card.Body>
                            <h1 className="card-title pricing-card-title">39.9<small className="text-body-secondary fw-light">/月</small></h1>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>240 分钟/天</li>
                                <li>30 天</li>
                            </ul>
                            <Button
                                variant="outline-success"
                                className="w-100 btn btn-lg"
                                onClick={() => handlePricingClick('240', '3990', '30天每天240分钟', "MEETING002", "CNY")}
                                >Get started</Button>
                        </Card.Body>
                    </Card>
                </Col>
<Col className="col-md-6 col-lg-3">
                    <Card className='mb-4 rounded-3 shadow-sm'>
                        <Card.Header className='py-3'>
                            <h4 className="my-0 fw-normal">Daypass</h4>
                        </Card.Header>
                        <Card.Body>
                            <h1 className="card-title pricing-card-title">29.9<small className="text-body-secondary fw-light">/天</small></h1>
                            <ul className="list-unstyled mt-3 mb-4">
                                <li>无限制</li>
                                <li>1 天</li>
                            </ul>
                            <Button
                                variant="outline-success"
                                className="w-100 btn btn-lg"
                                onClick={() => handlePricingClick('1440', '2990', '1天无限制', "MEETING003", "CNY")}
                                >Get started</Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
<h2 className="display-6 text-center mb-4">Compare plans</h2>
            <div className="table-responsive">
                <Table className="table text-center">
                    <thead>
                    <tr>
                        <th style={{ width: '24%' }}></th>
                        <th style={{ width: '19%' }}>10 min</th>
                        <th style={{ width: '19%' }}>90 min</th>
                        <th style={{ width: '19%' }}>240 min</th>
                        <th style={{ width: '19%' }}>Unlimited</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row" className="text-start">Free</th>
                        <td><i className="bi bi-check2"></i></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row" className="text-start">Pro</th>
                        <td><i className="bi bi-check2"></i></td>
                        <td><i className="bi bi-check2"></i></td>
                        <td></td>
                        <td></td>
                    </tr>
                    </tbody>

                    <tbody>
                    <tr>
                        <th scope="row" className="text-start">Enterprise</th>
                        <td><i className="bi bi-check2"></i></td>
                        <td></td>
                        <td><i className="bi bi-check2"></i></td>
                        <td></td>
                    </tr>                    
                    <tr>
                        <th scope="row" className="text-start">Daypass</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td><i className="bi bi-check2"></i></td>
                    </tr>                   
                    </tbody>
                </Table>
            </div>
        </>
    )

}

export default Pricing;



